module.exports = __webpack_public_path__ + "static/media/cart-serch-relevent.030fd7d7.svg";